import { useState } from "react"
const useBulkSelectHook = () => {
     const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] })
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk?.ids?.filter(optionItem => optionItem.id !== item.id) })
        }
    }
    const openBulkModal =()=>{setBulk({ ...bulk, title: 'Delete', modal: true })}
    const resetBulkToggle =()=>{
        setBulk({ modal: false, ids: [], title: '', type: '' })
    }
  return ({bulk,openBulkModal,toggleBulkOps,resetBulkToggle})
}

export default useBulkSelectHook